import { useEffect, useMemo } from 'react';

export default function useBlobUrl(blob) {

    const url = useMemo(() => {
        return blob ? URL.createObjectURL(blob) : null;
    }, [blob]);

    useEffect(() => {
        if (url) {
            return () => URL.revokeObjectURL(url);
        }
    }, [url]);

    return url;
}